import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PROJECT_WORKFLOW_STEPS, WorkflowStepEnumType } from '@shared/enums/workflow-step.enum';
import { selectWorkflowStep } from '@shared/observables/select-workflow-step';

@Pipe({
  name: 'workflowStepName',
})
export class WorkflowStepNamePipe implements PipeTransform {
  constructor(private store: Store<{}>) {}

  transform(step: WorkflowStepEnumType, fromProjectModule = false): Observable<string> {
    return selectWorkflowStep(this.store, step).pipe(
      map(step => {
        if (fromProjectModule && step.enumerationValue === WorkflowStepEnumType.Notice)
          return PROJECT_WORKFLOW_STEPS.find(el => el.value === WorkflowStepEnumType.Notice).displayValue;
        if (fromProjectModule && step.enumerationValue === WorkflowStepEnumType.MoveOut)
          return PROJECT_WORKFLOW_STEPS.find(el => el.value === WorkflowStepEnumType.MoveOut).displayValue;
        if (fromProjectModule && step.enumerationValue === WorkflowStepEnumType.MakeReady)
          return PROJECT_WORKFLOW_STEPS.find(el => el.value === WorkflowStepEnumType.MakeReady).displayValue;
        if (fromProjectModule && step.enumerationValue === WorkflowStepEnumType.MoveIn)
          return PROJECT_WORKFLOW_STEPS.find(el => el.value === WorkflowStepEnumType.MoveIn).displayValue;

        return step.displayText;
      })
    );
  }
}
